// src/components/AddStreetRangeDialog.js (Versión Completa y Funcional con Edición)
import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

const AddStreetRangeDialog = ({ open, onClose, onSubmit, initialData }) => {
  const [streetName, setStreetName] = useState('');
  const [startNumber, setStartNumber] = useState('');
  const [endNumber, setEndNumber] = useState('');
  const [route, setRoute] = useState('');

  useEffect(() => {
    if (open) {
      if (initialData) {
        setStreetName(initialData.street_name || '');
        setStartNumber(initialData.start_number || '');
        setEndNumber(initialData.end_number || '');
        setRoute(initialData.route || '');
      } else {
        // Limpiamos el formulario si estamos en modo "Añadir"
        setStreetName('');
        setStartNumber('');
        setEndNumber('');
        setRoute('');
      }
    }
  }, [initialData, open]);

  const handleSubmit = () => {
    const newData = {
      street_name: streetName,
      start_number: parseInt(startNumber, 10),
      end_number: parseInt(endNumber, 10),
      route: parseInt(route, 10),
    };
    onSubmit(newData);
    onClose(); // Dejamos que el padre decida si limpiar o no
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialData ? 'Edit Street Range' : 'Add New Street Range'}</DialogTitle>
      <DialogContent>
        <TextField autoFocus margin="dense" label="Street Name" type="text" fullWidth variant="standard" value={streetName} onChange={(e) => setStreetName(e.target.value)} />
        <TextField margin="dense" label="Start Number" type="number" fullWidth variant="standard" value={startNumber} onChange={(e) => setStartNumber(e.target.value)} />
        <TextField margin="dense" label="End Number" type="number" fullWidth variant="standard" value={endNumber} onChange={(e) => setEndNumber(e.target.value)} />
        <TextField margin="dense" label="Route" type="number" fullWidth variant="standard" value={route} onChange={(e) => setRoute(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddStreetRangeDialog;
